export default class CurrencyCustom {

  // Defines the currency codes supported by the application formatters.
  static get CURRENCIES() { return { EUR: "EUR", USD: "USD", GBP: "GBP" } }

  // Resolves the active application language to the corresponding formatting locale.
  static getLocale() {
    const culture = window.localStorage.getItem('culture') || 'en'
    const localeByCulture = {
      es: 'es-ES',
      en: 'en-US',
      pt: 'pt-PT'
    }
    return localeByCulture[culture] || localeByCulture.en
  }

  // Formats a value with the locale's grouping separator, including four-digit values.
  static formatWithGrouping(formatter, value) {
    const parts = formatter.formatToParts(value)
    const groupPart = formatter.formatToParts(10000).find(part => part.type === 'group')
    const groupSeparator = groupPart ? groupPart.value : null
    const hasGrouping = parts.some(part => part.type === 'group')

    if (!groupSeparator || Math.abs(Number(value)) < 1000 || hasGrouping) {
      return parts.map(part => part.value).join('')
    }

    // Some locales omit grouping for four-digit values, such as 1554; add it explicitly.
    let integerPartFormatted = false
    return parts.map(part => {
      if (part.type !== 'integer') return part.value
      if (integerPartFormatted) return ''

      integerPartFormatted = true
      return part.value.replace(/\B(?=(\d{3})+(?!\d))/g, groupSeparator)
    }).join('')
  }

  // Converts a decimal currency value to cents and formats it as euros.
  static toDecimalCurrency = (price) => {
    if (!this.isFloat(price)) return

    return this.currencyFormatter(this.CURRENCIES.EUR, (price * 100))
  }

  // Converts a currency value in cents to euros and formats it.
  static toFloatCurrency = (price) => {
    if (!this.isInteger(price)) return

    return this.currencyFormatter(this.CURRENCIES.EUR, (price / 100))
  }

  // Formats a monetary amount using the active locale.
  // Example: currencyFormatter('EUR', 1234.5) uses '1.234,50' in Spanish and '1,234.50' in English.
  static currencyFormatter(currency, value) {
    const formatter = new Intl.NumberFormat(this.getLocale(), {
      style: 'currency',
      minimumFractionDigits: 2,
      currency
    })
    return this.formatWithGrouping(formatter, value)
  }

  // Formats a whole number using the active locale's thousands separator.
  // Example: numberFormatter(1554) returns '1.554' for Spanish, '1,554' for English, and '1 554' for Portuguese.
  static numberFormatter(value) {
    const formatter = new Intl.NumberFormat(this.getLocale(), {
      maximumFractionDigits: 0
    })
    return this.formatWithGrouping(formatter, value)
  }

  // Determines whether a value is a valid number with decimal digits.
  static isFloat = (number) => {
    if (typeof number === 'number' && !isNaN(number)) {
      if (!Number.isInteger(number)) {
        return true
      }
    }
    return false
  }

  // Determines whether a value is a valid integer number.
  static isInteger = (number) => {
    if (typeof number === 'number' && !isNaN(number)) {
      if (Number.isInteger(number)) {
        return true
      }
    }
    return false
  }
}


// WEBPACK FOOTER //
// ./src/components/Utilities/CurrencyCustom.js